import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=e28c86c0&scoped=true&"
import script from "@/views/Subjects/Template.ts?vue&type=script&lang=ts&"
export * from "@/views/Subjects/Template.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Subjects/templates.scss?vue&type=style&index=0&id=e28c86c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28c86c0",
  null
  
)

export default component.exports